module.exports = __webpack_public_path__ + "static/media/Manish.38597702.jpg";